<template>
  <div class="LookGoods">
    <div class="lookBtn" @click="$router.push('/Goods?k=1')">
      <img src="../assets/img/lookBtn.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {
    // 移动端和pc端的切换
    if (
      window.navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
    ) {
      // 移动端
      if (window.location.href.includes("YHT")) {
        window.location.href = window.location.href.replace("YHT", "YHTM");
        setTimeout(() => {
          location.reload(true);
        }, 200);
      }
    }
  },
  mounted() {
    //
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.LookGoods {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/lookBg.jpg");
  background-size: 100% 100%;
  position: relative;
  .lookBtn {
    cursor: pointer;
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    & > img {
      width: 270px;
    }
  }
}
</style>